import { CourseOverview, User } from "../../model/model";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface UserError {
  message: string;
  code: string;
}
interface UserState {
  user: User | null;
  coursesOverview: CourseOverview[] | null;
  error: UserError | null;
}

const initialState: UserState = {
  user: null,
  coursesOverview: null,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserState["user"]>) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
    setCoursesOverview: (
      state,
      action: PayloadAction<UserState["coursesOverview"]>
    ) => {
      state.coursesOverview = action.payload;
    },
    setError: (state, action: PayloadAction<UserState["error"]>) => {
      state.error = action.payload;
    },
    clearErrors: (state) => {
      state.error = null;
    },
  },
});

export const userActions = userSlice.actions;
export default userSlice.reducer;
